export default __webpack_public_path__ + "static/media/BewerbungsProzess.f482e539.svg";